"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnersCarousel = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const ImageWrap = app_1.styled.div `
  width: 80%;
  height: 6rem;
  position: relative;
`;
function PartnersCarousel({ partners, }) {
    const remToPx = (0, app_1.useRemToPx)();
    return ((0, jsx_runtime_1.jsx)(ui_1.CarouselKeen, { data: partners, render: (partner) => {
            var _a;
            return ((0, jsx_runtime_1.jsx)(ImageWrap, Object.assign({ title: (_a = partner.title) !== null && _a !== void 0 ? _a : '' }, { children: partner.url ? ((0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: partner.url }, { children: (0, jsx_runtime_1.jsx)(app_1.Image, { img: partner.image, objectFit: "scale-down" }) }))) : ((0, jsx_runtime_1.jsx)(app_1.Image, { img: partner.image, objectFit: "scale-down" })) })));
        }, hideArrows: true, options: {
            defaultAnimation: {
                duration: 500,
            },
            breakpoints: {
                [app_1.notDesktop]: {
                    drag: true,
                    loop: true,
                    slides: {
                        perView: 2,
                        spacing: remToPx(2),
                    },
                },
                [app_1.notMobile]: {
                    drag: false,
                    loop: false,
                    slides: {
                        perView: 4,
                        spacing: remToPx(2),
                    },
                },
            },
        } }));
}
exports.PartnersCarousel = PartnersCarousel;
